import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Loading from "../../component/Loading/Loading";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import Objects from "../../utils/Objects";
import NotFound from "../../component/NotFound/NotFound";
import Notify from "../../services/Notify";
import CheckpointService from "../CheckpointService";
import ProfileCustomSelect from "../../profile/ProfileCustomSelect";
import FormButtons from "../../component/Form/FormButtons";
import {Alert, Form} from "react-bootstrap";

class CheckpointProfileSelect extends React.Component {

  service = new CheckpointService();

  constructor(props) {
    super(props);
    this.state = {loading: true};
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (Objects.isNullOrUndefined(id)) {
      return;
    }
    this.setState({loading: true});
    this.service.findById(id).then(
        data => this.setState(
            {
              loading: false,
              checkpoint: data,
              isIntegrated: data.isIntegrated
            }),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  submit() {
    const {history} = this.props;
    const {checkpoint} = this.state;

    this.service.saveProfiles(checkpoint.id, this.profileIds).then(
        () => Notify.success('Atualização efetuada') && history.push('/list/checkpoints'),
        error => {
          Notify.error('Problema ao associar', error);
        }
    );
  }

  render() {
    const {history} = this.props;
    const {loading, checkpoint} = this.state;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de Ponto de Controle" to="/list/checkpoints"/>,
      <BreadcrumbItem key={3} title="Perfil de acesso ao ponto de controle" active={true}/>];

    if (loading) {
      return <Loading/>;
    }

    if (Objects.isNullOrUndefined(checkpoint)) {
      return <NotFound/>;
    }

    return (
        <Page title={`Pontos de leitura do "${checkpoint.friendlyName}"`} breadcrumbs={breadcrumbs}>
          <Box info>
            <Form onSubmit={(e) => {
              e.preventDefault();
              this.submit();
            }}>
              <Alert>
                Selecione os perfis que podem usar este ponto de controle!
              </Alert>
              <ProfileCustomSelect companyId={checkpoint.company.id} profileIds={checkpoint.profiles.map(({id}) => id)}
                                   setValue={(value) => this.profileIds = value} history={history}/>
              <FormButtons history={this.props.history} style={{marginTop: '10px'}}/>
            </Form>
          </Box>
        </Page>);
  }
  ;
}

CheckpointProfileSelect.defaultProps = {
  checkpoint: null,
};

CheckpointProfileSelect.propTypes = {
  checkpoint: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default CheckpointProfileSelect;



// WEBPACK FOOTER //
// ./src/checkpoint/component/CheckpointProfileSelect.js